module.exports = __webpack_public_path__ + "img/img_level_5.149e7f09.png";